import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'caption'
})
export class CaptionPipe implements PipeTransform {


  userLang = localStorage.getItem('userLang') || 'en';

  constructor(private translate: TranslateService) {

  }

  transform(value: any, lang?: string): string {

    this.userLang = lang || this.translate.defaultLang;

    try {
      value = JSON.parse(value)[`${this.userLang}`];
    } catch {
      try {
        if (typeof value === 'object') {
          value = value[`${this.userLang}`];
        } else if (value && value.includes('{')) {
          value = JSON.parse(value)[`${this.userLang}`];
        } else {
          try {
            if (typeof value === 'object') {
              try {
                value = value.all;
              } catch {
                value = value.en;
              }
            } else if (value && value.includes('{')) {
              try {
                value = JSON.parse(value).all;
              } catch {
                value = JSON.parse(value).en;
              }
            }
          } catch {
            return value;
          }

        }
      } catch {
        return value;
      }
    }

    return value;
  }

}
